let env = process.env.REACT_APP_ENV || 'DEV';

const configuration = () => {
    /* prod configuration */
    const fields = {
        subCategory1: '00N37000004PJjG',
        preferredMethodOfContact: '00N37000005R6nQ',
        preferredContactTime: '00N37000006j5sN',
        locationID: '00N37000006j5sM',
        dateOfVisit: '00N37000004PJj3',
        timeOfVisit: '00N37000004PJjL',
        typeOfVisit: '00N37000004PJwx',
        amPm: '00N37000004PJiz',
        orgId: '00D37000000PbrE',
        captchaKeyName: 'DotCom_Recaptcha_Key',
        servletUrl: 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8'
    };
    /*  if the sandbox and prod environment get out of sync,
        add field overrides for environment below
    */
    if (env !== 'PROD') {
        fields.orgId = '00D2F0000009EAn';
        fields.captchaKeyName = 'techlabdev';
        fields.servletUrl = 'https://cs91.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8';
    }
    return fields;
};

/**
 * Configuration Wrapper for Unit Testing
 * @param environment {string}
 * @description Wrapper for instantiation of configuration with appropriate environment for testing
 * @returns {*}
 */
export const configWrapperForUnitTest = (environment) => {
    env = environment;
    return configuration();
};

const config = configuration();

export default config;




// WEBPACK FOOTER //
// ./src/config/index.js